import { css } from '@emotion/react';
import { styled } from '@mui/material';
import { TableType } from '../model/rolesAndPerms.model';
import zeplinColor from '../theme/Color';

const DashboardTable: TableType = {
  id: 1,
  columns: [
    { name: 'Dashboard', value: false, indeterminate: false },
    { name: 'View', value: false, indeterminate: false },
    { name: 'View / Create / Edit', value: false, indeterminate: false },
    { name: 'View / Create / Edit / Delete', value: false, indeterminate: false },
  ],
  rows: [
    { name: 'Overview', values: [false, false, false, false] },
    { name: 'Activity', values: [false, false, false, false] },
    { name: 'Calendar', values: [false, false, false, false] },
  ],
};

const ClientsTable: TableType = {
  id: 2,
  columns: [
    { name: 'Clients', value: false, indeterminate: false },
    { name: 'View', value: false, indeterminate: false },
    { name: 'View / Create / Edit', value: false, indeterminate: false },
    { name: 'View / Create / Edit / Delete', value: false, indeterminate: false },
  ],
  rows: [
    { name: 'Client List', values: [false, false, false, false] },
    { name: 'Priorities', values: [false, false, false, false] },
    { name: 'Profile Details', values: [false, false, false, false] },
    { name: 'Deals', values: [false, false, false, false] },
    { name: 'Task', values: [false, false, false, false] },
    { name: 'Communication', values: [false, false, false, false] },
    { name: 'Revenue', values: [false, false, false, false] },
    { name: 'Social', values: [false, false, false, false] },
    { name: 'Calendar', values: [false, false, false, false] },
    { name: 'Contacts', values: [false, false, false, false] },
    { name: 'Files', values: [false, false, false, false] },
  ],
};

const TeamsTable: TableType = {
  id: 3,
  columns: [
    { name: 'Teams', value: false, indeterminate: false },
    { name: 'View', value: false, indeterminate: false },
    { name: 'View / Create / Edit', value: false, indeterminate: false },
    { name: 'View / Create / Edit / Delete', value: false, indeterminate: false },
  ],
  rows: [
    { name: 'Members', values: [false, false, false, false] },
    { name: 'Profile', values: [false, false, false, false] },
    { name: 'Task', values: [false, false, false, false] },
    { name: 'Assignments', values: [false, false, false, false] },
  ],
};

const TasksTable: TableType = {
  id: 4,
  columns: [
    { name: 'Tasks', value: false, indeterminate: false },
    { name: 'View', value: false, indeterminate: false },
    { name: 'View / Create / Edit', value: false, indeterminate: false },
    { name: 'View / Create / Edit / Delete', value: false, indeterminate: false },
  ],
  rows: [
    { name: 'My Tasks', values: [false, false, false, false] },
    { name: 'All Tasks', values: [false, false, false, false] },
    { name: 'Task Details', values: [false, false, false, false] },
  ],
};
const DealsTable: TableType = {
  id: 5,
  columns: [
    { name: 'Deals', value: false, indeterminate: false },
    { name: 'View', value: false, indeterminate: false },
    { name: 'View / Create / Edit', value: false, indeterminate: false },
    { name: 'View / Create / Edit / Delete', value: false, indeterminate: false },
  ],
  rows: [
    { name: 'My Deals', values: [false, false, false, false] },
    { name: 'All Deals', values: [false, false, false, false] },
    { name: 'Deal Details', values: [false, false, false, false] },
  ],
};

const LeadsTable: TableType = {
  id: 6,
  columns: [
    { name: 'Leads', value: false, indeterminate: false },
    { name: 'View', value: false, indeterminate: false },
    { name: 'View / Create / Edit', value: false, indeterminate: false },
    { name: 'View / Create / Edit / Delete', value: false, indeterminate: false },
  ],
  rows: [
    { name: 'My Leads', values: [false, false, false, false] },
    { name: 'All Leads', values: [false, false, false, false] },
    { name: 'Potential Leads', values: [false, false, false, false] },
    { name: 'Lead Details', values: [false, false, false, false] },
  ],
};
const ContactsTable: TableType = {
  id: 7,
  columns: [
    { name: 'Contacts', value: false, indeterminate: false },
    { name: 'View', value: false, indeterminate: false },
    { name: 'View / Create / Edit', value: false, indeterminate: false },
    { name: 'View / Create / Edit / Delete', value: false, indeterminate: false },
  ],
  rows: [
    { name: 'My Contacts', values: [false, false, false, false] },
    { name: 'All Contacts', values: [false, false, false, false] },
    { name: 'Businesses', values: [false, false, false, false] },
    { name: 'Contact Details', values: [false, false, false, false] },
  ],
};
const BusinessesTable: TableType = {
  id: 8,
  columns: [
    { name: 'Businesses', value: false, indeterminate: false },
    { name: 'View', value: false, indeterminate: false },
    { name: 'View / Create / Edit', value: false, indeterminate: false },
    { name: 'View / Create / Edit / Delete', value: false, indeterminate: false },
  ],
  rows: [
    { name: 'My Businesses', values: [false, false, false, false] },
    { name: 'All Businesses', values: [false, false, false, false] },

    { name: 'Business Details/Relationship', values: [false, false, false, false] },
    { name: 'Company Intel', values: [false, false, false, false] },
    { name: 'Contacts', values: [false, false, false, false] },
    { name: 'Platform Insights', values: [false, false, false, false] },
    { name: 'News', values: [false, false, false, false] },
    { name: 'Similar Companies', values: [false, false, false, false] },
  ],
};

const TableData: { [key: string]: TableType } = {
  Dashboard: DashboardTable,
  Clients: ClientsTable,
  Teams: TeamsTable,
  Tasks: TasksTable,
  Deals: DealsTable,
  Contacts: ContactsTable,
  Businesses: BusinessesTable,
  Leads: LeadsTable,
};
export const tables: TableType[] = [
  DashboardTable,
  ClientsTable,
  TeamsTable,
  TasksTable,
  DealsTable,
  ContactsTable,
  BusinessesTable,
  LeadsTable,
];

// Column index (0-based in values array) → permission key sent to API
// col 0 = "View"              → read
// col 1 = "View/Create/Edit"  → create  (backend grants read+create+edit)
// col 2 = "V/C/E/Delete"      → delete  (backend grants all four)
const COL_TO_PERM_KEYS: Record<number, string[]> = {
  0: ['View'],
  1: ['View', 'Create', 'Edit'],
  2: ['View', 'Create', 'Edit', 'Delete'],
};

// Incoming permission action → which column (values index) it belongs to
const PERM_KEY_TO_COL: Record<string, number> = {
  View: 0,
  Create: 1,
  Edit: 1,
  Delete: 2,
};

/**
 * Converts active table checkboxes → permission strings for PUT /admin/roles/:id
 * Column tiers: values[0]=read, values[1]=create(r+c+e), values[2]=delete(all)
 * e.g. "Dashboard.Overview.read", "Tasks.FullAccess"
 */
export const mapTablesToRolePermissions = (sourceTables: TableType[]): string[] => {
  const permissions: string[] = [];

  sourceTables.forEach((table) => {
    const moduleName = table.columns[0].name;
    const allChecked = table.rows.every((row) => row.values[0] && row.values[1] && row.values[2]);

    if (allChecked) {
      permissions.push(`${moduleName}.FullAccess`);
      return;
    }

    table.rows.forEach((row) => {
      const resourceName = row.name.replace(/\s+/g, '');
      const highestCol = [2, 1, 0].find((colIdx) => row.values[colIdx]);
      if (highestCol !== undefined) {
        COL_TO_PERM_KEYS[highestCol].forEach((action) => {
          permissions.push(`${moduleName}.${resourceName}.${action}`);
        });
      }
    });
  });

  return permissions;
};

/**
 * Converts permission strings from GET /admin/roles/:id → table checkbox state
 * Handles both string format ("Dashboard.Overview.read") and Permission objects
 */
export const mapRolePermissionsToTables = (rolePermissions: any[] = []): TableType[] => {
  const nextTables: TableType[] = JSON.parse(JSON.stringify(tables));

  rolePermissions.forEach((perm) => {
    // string format: "Module.Resource.action" or "Module.FullAccess"
    if (typeof perm === 'string') {
      const parts = perm.split('.');
      const moduleName = parts[0];
      const table = nextTables.find((t) => t.columns[0].name === moduleName);
      if (!table) return;

      if (parts[1] === 'FullAccess') {
        table.rows.forEach((row) => {
          row.values[0] = true;
          row.values[1] = true;
          row.values[2] = true;
        });
        return;
      }

      const resourceName = parts[1];
      const action = parts[2];
      const row = table.rows.find((r) => r.name.replace(/\s+/g, '') === resourceName);
      const colIdx = PERM_KEY_TO_COL[action?.toLowerCase()];
      if (row && colIdx !== undefined) row.values[colIdx] = true;
      return;
    }

    // Permission object format from API response
    const table = nextTables.find(
      (t) => t.columns[0].name.toLowerCase() === perm.module?.toLowerCase(),
    );
    if (!table) return;

    const permName: string = perm.name || '';
    // name may be "read:overview" or plain resource name
    const resourceSegment = permName.includes(':') ? permName.split(':')[1] : permName;
    const row = table.rows.find(
      (r) =>
        r.name.replace(/\s+/g, '').toLowerCase() ===
        resourceSegment.replace(/\s+/g, '').toLowerCase(),
    );
    const colIdx = PERM_KEY_TO_COL[perm.action?.toLowerCase()];
    if (row && colIdx !== undefined) row.values[colIdx] = true;
  });

  // Sync column header states after populating rows
  return nextTables.map((table) => {
    const newColumns = JSON.parse(JSON.stringify(table.columns));
    for (let ci = 1; ci < newColumns.length; ci++) {
      const vi = ci - 1;
      const allChecked = table.rows.every((r) => r.values[vi]);
      const someChecked = table.rows.some((r) => r.values[vi]);
      newColumns[ci].value = allChecked;
      newColumns[ci].indeterminate = someChecked && !allChecked;
    }
    newColumns[0].value = table.rows.every((r) => r.values[0] && r.values[1] && r.values[2]);
    newColumns[0].indeterminate =
      !newColumns[0].value && table.rows.some((r) => r.values.some(Boolean));
    return { ...table, columns: newColumns };
  });
};

export const Icon = styled('span')(
  css({
    borderRadius: 3,
    width: '24px',
    height: '24px',
    border: `1px solid ${zeplinColor.BasicBlack}`,
    '.Mui-focusVisible &': {
      outline: `2px auto ${zeplinColor.Brand1}`,
    },
    'input:hover ~ &': {
      backgroundColor: zeplinColor.Neutral4,
    },
  }),
);

export const CheckedIcon = styled(Icon)(
  css({
    backgroundColor: zeplinColor.BasicBlack,
    '&::before': {
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: zeplinColor.BasicBlack,
    },
  }),
);

export const IndeterminateIcon = styled(Icon)(
  css({
    backgroundColor: zeplinColor.BasicBlack,

    '&::before': {
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Crect" +
        " x='3' y='7' width='10' height='2' rx='1' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: zeplinColor.BasicBlack,
    },
  }),
);

type ActionType = 'view' | 'create' | 'edit' | 'delete';

const ACTION_MAP: Record<ActionType, number> = {
  view: 0,
  create: 1,
  edit: 2,
  delete: 3,
};

export const transformPermissionsToTables = (
  allPermissions: any[],
  rolePermissions: any[] = [],
): TableType[] => {
  // Create a Set of IDs for fast lookup
  const rolePermIds = new Set(rolePermissions.map((p) => p.permissionId));

  // 1. Group all available permissions by Module and Name
  const grouped = allPermissions.reduce((acc: any, item: any) => {
    if (!acc[item.module]) acc[item.module] = {};
    if (!acc[item.module][item.name]) {
      acc[item.module][item.name] = [false, false, false, false];
    }

    const index = ACTION_MAP[item.action as ActionType];
    if (index !== undefined) {
      // Set true only if the role actually has this specific permission
      if (rolePermIds.has(item.permissionId)) {
        acc[item.module][item.name][index] = true;
      }
    }
    return acc;
  }, {});

  // 2. Map the grouped object into TableType structure
  return Object.keys(grouped).map((moduleName, idx) => {
    const rowData = Object.keys(grouped[moduleName]).map((rowName, idx) => ({
      name: TableData[moduleName]?.rows[idx]?.name || rowName, // Use the name from TableData if available, otherwise fallback to rowName
      values: grouped[moduleName][rowName] as [boolean, boolean, boolean, boolean],
    }));

    // Generate columns and calculate initial header checkbox states (All/Indeterminate)
    const columns = [
      { name: moduleName, value: false, indeterminate: false }, // Module Header
      ...['View', 'View / Create / Edit', 'View / Create / Edit / Delete'].map((colName, i) => {
        const allChecked = rowData.every((row) => row.values[i]);
        const someChecked = rowData.some((row) => row.values[i]);
        return {
          name: colName,
          value: allChecked,
          indeterminate: someChecked && !allChecked,
        };
      }),
    ];

    // Calculate the "Full Access" (index 0) header state
    const allRowsChecked = rowData.every((r) => r.values.every((v) => v));
    columns[0].value = allRowsChecked;

    return {
      id: idx + Date.now(),
      columns,
      rows: rowData,
    };
  });
};
